import { createAction } from 'redux-actions';

export const UPDATE_APPLE_BUTTON_ACTION = 'UPDATE_APPLE_BUTTON';

export const updateSignInWithApple = createAction(UPDATE_APPLE_BUTTON_ACTION, value => value);